/*
 * Site-wide guard: the free "22 Pound Margin" eBook (SKU "eBook") is a bundle
 * bonus and must never be checked out on its own.
 *
 * Complements the per-surface blocks in main-cart-footer / main-cart-items /
 * elycera-cart-drawer (which only cover those UIs). This runs on every layout
 * and only ever BLOCKS checkout triggers while the cart is eBook-only. It never
 * modifies the cart, and every failure path leaves checkout working.
 *
 * Theme code can't stop a hand-typed /checkout URL — the Shopify checkout
 * validation Function is the hard block for that.
 */
(function () {
  if (window.__elyEbookGuard) return;
  window.__elyEbookGuard = true;

  var blocked = false;
  var seq = 0;

  function ebookOnly(cart) {
    return !!(cart && cart.items && cart.items.length > 0 &&
      cart.items.every(function (it) { return it.sku === 'eBook'; }));
  }

  // Always re-read the full cart. Mutation responses (e.g. /cart/add.js) only
  // describe the changed lines, so they can't be used to judge the whole cart.
  function refresh() {
    var mine = ++seq;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (mine !== seq || !cart) return; // stale or failed read: keep last known state
        blocked = ebookOnly(cart);
        document.documentElement.classList.toggle('ely-ebook-only-cart', blocked);
      })
      .catch(function () {});
  }

  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input) {
        var p = nativeFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            p.then(refresh, function () {});
          }
        } catch (e) {}
        return p;
      };
    }
  } catch (e) {}

  var CHECKOUT_HREF = /^(https?:)?(\/\/[^/]+)?\/checkout([/?#]|$)/;
  var CHECKOUT_BTN = '[name="checkout"], shopify-accelerated-checkout-cart';

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    var a = el.closest('a[href]');
    if (a && CHECKOUT_HREF.test(a.getAttribute('href') || '')) return true;
    return !!el.closest(CHECKOUT_BTN);
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.alert("The free eBook can't be checked out on its own. It ships automatically with an AFM/DFM Disabler order.");
  }

  document.addEventListener('click', function (e) {
    if (blocked && isCheckoutTrigger(e.target)) stop(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (blocked && e.submitter && e.submitter.name === 'checkout') stop(e);
  }, true);

  // Cart may have changed in another tab, or a page restored from bfcache.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  refresh();
})();
